/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerDeleteArticleResponse } from './BlogManagerDeleteArticleResponse';

export type BlogManagerDeleteArticleResponseApiRespoonse = {
    data?: BlogManagerDeleteArticleResponse;
    status?: BlogManagerDeleteArticleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BlogManagerDeleteArticleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

